import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import React from "react";
import IconLogo from "components/IconLogo";

export const NavBrand = () => {
  return (
    <div className="nav-left">
      <Navbar.Brand>
        <Link to="/dashboard">
          <IconLogo />
        </Link>
      </Navbar.Brand>
    </div>
  );
};

export default NavBrand;
